import axios from "axios";
import { authBearerToken } from "utils/auth";
import { updateIntegrationAction } from "actions/integration";
import get from "lodash/get";

const getDefaultInput = (uid) => ({
  value: null,
  uid
});

export const mergeDocusignTemplateRecipients = ({
  template,
  currentRecipients,
  initialRecipients
}) => {
  const result = {};
  for (const receiverType in template.recipients) {
    result[receiverType] = [];
    const receivers = template.recipients[receiverType];
    const currentTypeReceivers = currentRecipients
      ? currentRecipients[receiverType] || []
      : [];
    const initialTypeReceivers = initialRecipients
      ? initialRecipients[receiverType] || []
      : [];

    for (let recIx = 0; recIx < receivers.length; recIx++) {
      const receiver = receivers[recIx];
      if (receiver.roleName) {
        /**
         * Find receiver for roleName
         */
        const currentMatch = currentTypeReceivers.find(
          ({ roleName }) => roleName === receiver.roleName
        );

        const initialMatch = initialTypeReceivers.find(
          ({ roleName }) => roleName === receiver.roleName
        );

        const matchingReceiver = currentMatch || initialMatch;

        const matchingReceiverTextTabs = get(matchingReceiver, "tabs.textTabs");
        const matchingReceiverName = get(matchingReceiver, "name");
        const matchingReceiverEmail = get(matchingReceiver, "email");
        const name = matchingReceiverName || getDefaultInput("name");
        const email = matchingReceiverEmail || getDefaultInput("email");

        const updatedReceiver = {
          name,
          email,
          roleName: receiver.roleName,
          tabs: null
        };

        if (template.tabs && Array.isArray(template.tabs.textTabs)) {
          template.tabs.textTabs.forEach((textTab) => {
            if (!updatedReceiver.tabs) {
              updatedReceiver.tabs = {};
            }
            if (!updatedReceiver.tabs.textTabs) {
              updatedReceiver.tabs.textTabs = [];
            }

            let currentMatchingTab;
            if (matchingReceiverTextTabs) {
              currentMatchingTab = matchingReceiverTextTabs.find(
                ({ uid }) => uid === textTab.tabLabel
              );
            }

            const updatedTab = currentMatchingTab || {
              enabled: true,
              uid: textTab.tabLabel,
              value: null,
              type: textTab.tabType,
              config: {
                locked: "true"
              }
            };

            updatedReceiver.tabs.textTabs.push(updatedTab);
          });
        }

        result[receiverType].push(updatedReceiver);
      }
    }
  }

  return result;
};

export const fetchDocusignTemplate = async ({
  url,
  setLoading,
  dispatch,
  integration,
  onError,
  onSuccess
}) => {
  setLoading(true);

  try {
    const { data } = await axios({
      method: "get",
      url,
      headers: authBearerToken(),
      params: {
        expand: ["documents.tabs"]
      }
    });

    dispatch(
      updateIntegrationAction({
        id: integration.id,
        _data: {
          templates: {
            [data.templateId]: data
          }
        }
      })
    );
    onSuccess && onSuccess(data);
  } catch (error) {
    onError(error);
  }
  setLoading(false);
};

export const fetchDocusignTemplates = async ({
  url,
  setLoading,
  dispatch,
  integration,
  onError,
  onSuccess
}) => {
  setLoading(true);

  try {
    const { data } = await axios({
      method: "get",
      url,
      headers: authBearerToken()
    });

    const allTemplates = data.envelopeTemplates.reduce((memo, template) => {
      memo[template.templateId] = template;
      return memo;
    }, {});

    dispatch(
      updateIntegrationAction({
        id: integration.id,
        _data: {
          templates: allTemplates
        }
      })
    );
    onSuccess && onSuccess(data);
  } catch (error) {
    onError(error);
  }
  setLoading(false);
};
